import { useSelector } from 'react-redux';

/**
 * Custom hook for accessing site information from Redux.
 *
 * Redux is the single source of truth for site selection.
 * SiteSelect component is responsible for:
 * - Reading URL siteCode on initial load
 * - Updating Redux when user selects a site
 * - Keeping URL in sync with Redux
 *
 * This hook only provides read access to the current site data.
 *
 * Usage:
 *   const { selectedSite, siteId, siteCode } = useSiteSync();
 *
 * @returns {Object} - { selectedSite, siteId, siteCode, languageId, siteGroupId }
 */
function useSiteSync() {
  const selectedSite = useSelector((state) => state.user?.loginResponse?.selectedSite);

  return {
    selectedSite,
    siteId: selectedSite?.SiteId || null,
    siteCode: selectedSite?.SiteCode || null,
    languageId: selectedSite?.LanguageId || null,
    siteGroupId: selectedSite?.SiteGroupId || null,
  };
}

export default useSiteSync;
